module.exports = __webpack_public_path__ + "static/media/ouverture.ba1b5363.jpg";